import { ColumnExtended } from '../../types/ColumnExtended';
import { LUCTransferReceiptItem } from '../../types/luc-transfer-receipt';

export const makeLucTransferReceiptItemColumns = () => {
  const col: ColumnExtended<LUCTransferReceiptItem>[] = [
    {
      header: 'Serial Number',
      accessorKey: 'serialNumber',
      enableColumnFilter: false,
      size: 120,
    },
    {
      header: '# Nets',
      accessorKey: 'support_NrOfNets',
      enableColumnFilter: false,
      size: 80,
    },
    {
      header: '# Doors',
      accessorKey: 'support_NrOfDoors',
      enableColumnFilter: false,
      size: 80,
    },
    {
      header: '# Straps',
      accessorKey: 'support_NrOfStraps',
      enableColumnFilter: false,
      size: 80,
    },
    {
      header: '# Fittings',
      accessorKey: 'support_NrOfFittings',
      enableColumnFilter: false,
      size: 90,
    },
    {
      header: 'Final Destination',
      accessorKey: 'toStationIataCode',
      enableColumnFilter: false,
      size: 130,
    },
    {
      header: 'Demurrage Code',
      accessorKey: 'demurrageCode',
      enableColumnFilter: false,
      size: 140,
    },
    {
      header: 'Damage',
      accessorKey: 'isDamaged',
      enableColumnFilter: false,
      size: 80,
      cell: ({ row }) => (row.original.isDamaged ? 'Yes' : 'No'),
    },
    {
      header: 'ODLN Code',
      accessorKey: 'odlnCode',
      enableColumnFilter: false,
      size: 100,
    },
    {
      header: 'Damage Description',
      accessorKey: 'damageDescription',
      enableColumnFilter: false,
      size: 120,
    },
  ];

  return col;
};
